module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingClans/components/Card/components/Back/images/banner.c46da848.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Card/components/Back/images/banner.png
// module id = 1358
// module chunks = 11